import clsx from 'clsx';
import { AVATARS } from '@mafia/core';

export function Avatar({ id, name, size = 40, className }: { id: string | null | undefined; name: string; size?: number; className?: string }) {
  const avatar = AVATARS.find((a) => a.id === id);
  return (
    <span
      className={clsx('inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold text-white', className)}
      style={{
        width: size,
        height: size,
        fontSize: avatar ? size * 0.55 : size * 0.42,
        background: avatar ? `${avatar.color}33` : '#2a2a37',
        boxShadow: avatar ? `inset 0 0 0 1.5px ${avatar.color}88` : 'inset 0 0 0 1.5px rgba(255,255,255,.08)',
      }}
      aria-hidden
    >
      {avatar ? avatar.emoji : name.slice(0, 1).toUpperCase()}
    </span>
  );
}
